


import React, { useState, useEffect } from 'react';
import { ChevronUp, MessageSquare } from 'lucide-react';

const ClientShowcase = () => {
  const [activeSlide, setActiveSlide] = useState(0);
  
  // Updated color palette with blue colors instead of green
  const colors = {
    darkBlue: "#1E3A5B",      // Dark blue for nav (replacing darkGreen)
    mediumBlue: "#2E5C8B",    // Medium blue for accent elements (replacing mediumGreen)
    lightBlue: "#E7EDF2",     // Light blue for backgrounds (replacing lightGreen)
    accentBlue: "#3869A1",    // Bright blue for interactive elements (replacing accentGreen)
    hoverBlue: "#9FBFDF",     // Hover state blue (replacing hoverGreen)
    white: "#FFFFFF",
    black: "#000000",
    darkGray: "#333333",
    mediumGray: "#717171",
    lightGray: "#E5E5E5",
    borderGray: "#EAEAEA"
  };
  
  const clients = [
    [
      { name: "GS BATTERY", logo: "https://ik.imagekit.io/kqumni8l2/Infor_Clients/PT-GS-Battery.png?updatedAt=1737435858969" },
      { name: "CHAIYABOON", logo: "https://ik.imagekit.io/kqumni8l2/Infor_Clients/Chaiyaboon.png?updatedAt=1735885001776" },
      { name: "AWAL GULF", logo: "https://ik.imagekit.io/kqumni8l2/Infor_Clients/AvalGulf.png?updatedAt=1735885001734" },
      { name: "SANDEN", logo: "https://ik.imagekit.io/kqumni8l2/Infor_Clients/Saden.png?updatedAt=1735885001834" },
    ],
    [
      { name: "SANOH", logo: "https://ik.imagekit.io/kqumni8l2/Infor_Clients/Sanoh.png?updatedAt=1735885002227" },
      { name: "CMR GREEN TECHNOLOGIES", logo: "https://ik.imagekit.io/kqumni8l2/Infor_Clients/CMR.png?updatedAt=1735885002372" },
      { name: "VANDEWIELE-SAVIO", logo: "https://ik.imagekit.io/kqumni8l2/Infor_Clients/Savio.png?updatedAt=1735885002140" },
      { name: "L&T DEFENCE", logo: "https://ik.imagekit.io/kqumni8l2/Infor_Clients/LT.png?updatedAt=1735885002145" },
    ],
    [
      { name: "KEPPEL", logo: "https://ik.imagekit.io/kqumni8l2/Infor_Clients/Keppel_Ltd_Logo_infor_coustomer.png?updatedAt=1741675039107" },
      { name: "VIRBAC", logo: "https://ik.imagekit.io/kqumni8l2/Infor_Clients/Virbac_logo_infor_coustomer.png?updatedAt=1741675038989" },
      { name: "MICHAEL", logo: "https://ik.imagekit.io/kqumni8l2/Infor_Clients/Michael-Page%20_infor%20coustomer.png?updatedAt=1741675039209" },
      { name: "MAKING SCIENCE", logo: "https://ik.imagekit.io/kqumni8l2/Infor_Clients/Making%20Science%20_infor_coustomer.png?updatedAt=1741675039222" },
    ]
  ];

  // Auto-scroll functionality
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveSlide((prev) => (prev + 1) % clients.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [clients.length]);

  // Function to get color based on retention value
  const getColorStyle = (color) => {
    return { backgroundColor: color };
  };

  return (
    <div className="w-full bg-white  h-auto ">
      
      {/* Clients Section */}
      <div className="w-full mt-8">
        <div className="relative overflow-hidden ">
          {/* Background with light pattern */}
          <div className="absolute inset-0 opacity-70 z-0" 
               style={{ background: `linear-gradient(to right, ${colors.lightBlue}, ${colors.white})` }}></div>
          
          {/* Header with decorative elements */}
          <div className="relative z-10">
            <div className="container mx-auto px-4">
              <div className="text-center mb-12 relative">
                <span className="inline-block px-4 py-1 text-sm font-medium rounded-full mb-3" 
                      style={{ backgroundColor: `${colors.lightBlue}`, color: colors.darkBlue }}>
                  Clients First
                </span>
                <h1 className="text-4xl font-bold relative inline-block" style={{ color: colors.darkGray }}>
                  Some Of Our Customers
                    <div className="w-40 h-1 rounded-full text-center mx-auto" 
                   style={{ background: "linear-gradient(to right, #1E3A5B, #5985B1, #3869A1)" }}></div>
                </h1>
              </div>
            </div>
          </div>
          
          {/* Client Logos Carousel */}
          <div className="container mx-auto px-4 relative z-10">
            <div className="bg-white rounded-xl p-8 border" style={{ borderColor: colors.lightBlue }}>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
                {clients[activeSlide].map((client, index) => (
                  <div 
                    key={`${client.name}-${index}`}
                    className="group flex flex-col items-center justify-center p-6 rounded-lg transition-all duration-500 hover:shadow-lg bg-white border"
                    style={{ borderColor: colors.borderGray, hover: { borderColor: colors.mediumBlue } }}
                  >
                    <div className="w-full h-24 flex items-center justify-center overflow-hidden">
                      <img 
                        src={client.logo} 
                        alt={client.name} 
                        className="max-h-16 sm:max-h-24 max-w-full object-contain"
                      />
                    </div>
                    <div className="mt-4 overflow-hidden h-0 opacity-0 group-hover:h-auto group-hover:opacity-100 transition-all duration-300">
                      <span style={{ color: colors.mediumBlue }} className="font-medium">{client.name}</span>
                    </div>
                  </div>
                ))}
              </div>
              
              {/* Pagination Dots */}
              <div className="flex justify-center mt-8 space-x-2">
                {clients.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setActiveSlide(index)}
                    className={`h-3 rounded-full transition-all duration-300 ${
                      activeSlide === index ? "w-6" : "w-3 hover:opacity-80"
                    }`}
                    style={{ 
                      backgroundColor: activeSlide === index ? colors.accentBlue : colors.lightGray
                    }}
                    aria-label={`Go to slide ${index + 1}`}
                  />
                ))}
              </div>
            </div>
          </div>
          
          {/* Decorative Elements */}
          <div className="absolute top-0 right-0 w-64 h-64 rounded-full -mr-32  z-0" 
               style={{ backgroundColor: colors.lightBlue }}></div>
          <div className="absolute bottom-0 left-0 w-48 h-48 rounded-full -ml-24  z-0" 
               style={{ backgroundColor: colors.lightBlue }}></div>
          <div className="absolute top-1/2 left-1/4 w-16 h-16 rounded-full -ml-8  opacity-30 z-0" 
               style={{ backgroundColor: colors.mediumBlue }}></div>
          <div className="absolute bottom-1/3 right-1/3 w-24 h-24 rounded-full -mr-12  opacity-40 z-0" 
               style={{ backgroundColor: colors.lightBlue }}></div>
        </div>
      </div>
      
      {/* Back to Top Button */}
      <div className="fixed  right-8 z-50">
        <button 
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          className="p-3 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 group border"
          style={{ backgroundColor: colors.white, borderColor: colors.lightBlue }}
          aria-label="Back to top"
        >
          <ChevronUp 
            style={{ color: colors.accentBlue }}
            size={24}
            className="transition-transform duration-300" 
          />
        </button>
      </div>
      
      
    </div>
  );
};

export default ClientShowcase;